import { Route, Switch, useLocation } from 'react-router-dom';
import { InviteLandingPage } from '../../features/invitations/invite-landing.page';
import { AuthenticatedApi } from '../../core/api/components/authenticated-api.component';
import { useAuthInitEffect } from '../../core/workos/auth-init-effect.hook';
import { NoProjectPage } from './authenticated-root.component';
import { ProjectRouter } from './project.router';
import { useEffect } from 'react';
import { Login } from './login';

// Just specify the paths (don't need a function to build each path)
export enum Paths {
  project = '/projects/:projectID',
  welcome = '/projects/:projectID/welcome',
  dashboard = '/projects/:projectID/dashboard',
  hubs = '/projects/:projectID/hubs',
  container = '/projects/:projectID/containers/:deliveryContainerID',
  customers = '/projects/:projectID/users',
  customer = '/projects/:projectID/users/:userID',
  customerOfChildProject = '/projects/:projectID/users/:userID/childProject/:childProjectID',
  couriers = '/projects/:projectID/couriers',
  courier = '/projects/:projectID/couriers/:courierID',
  carriers = '/projects/:projectID/carriers',
  carrier = '/projects/:projectID/carriers/:carrierID',
  pendingCarriers = '/projects/:projectID/pendingCarriers',
  pendingCouriers = '/projects/:projectID/pendingCouriers',
  incompleteCouriers = '/projects/:projectID/incompleteCouriers',
  orders = '/projects/:projectID/orders',
  order = '/projects/:projectID/orders/:orderID',
  team = '/projects/:projectID/team',
  teamMember = '/projects/:projectID/team/:teamMemberID',
  user = '/global/users/:userID',
  userAccess = '/global/useraccess',
  invite = '/invite',
  login = '/login',
  lockerUtilisationReport = '/projects/:projectID/lockerUtilisationReport',
  deliveryContainerUtilisationReport = '/projects/:projectID/deliveryContainerUtilisationReport',
  kioskConnectionStatusReport = '/projects/:projectID/kioskConnectionStatusReport',
  kioskConnectionStatusDetail = '/projects/:projectID/kioskConnectionStatusReport/:kioskID',
  deliveriesRequiringAttention = '/projects/:projectID/requiringAttention',
  courierLoginTesting = '/projects/:projectID/courierLoginTesting',
  deliveries = '/projects/:projectID/deliveries',
  deliveriesInternal = '/projects/:projectID/InternalView',
  delivery = '/projects/:projectID/deliveries/:deliveryID',
  permissions = '/projects/:projectID/permissions',
  settings = '/projects/:projectID/settings'
}

// type to extract the required params from a path - similar to how react-router does it
// This type also adds the optional shortcode property if the path includes 'projectID' (ts magic ;)
type ExtractPathParams<P extends string> = P extends `${infer _Start}:${infer Param}/${infer Rest}`
  ? { [K in Param | keyof ExtractPathParams<Rest>]: string }
  : P extends `${infer _Start}:${infer Param}`
  ? { [K in Param]: string }
  : {};
// Narrows the type returned above to be strictly typed to the given path
export type PathParams<P extends Paths> = ExtractPathParams<P>;
// Add optional shortcode property to path params, if the path contains ":projectID"
export type ProjectPathParams<P extends Paths> = PathParams<P> &
  (P extends `${infer _Start}:projectID${infer _Rest}` ? { shortcode?: string } : {});

// this function will build a dynamic path, and its strictly typed :)
// it just returns a string, but we don't need typing on that
export function createPath<P extends Paths>(path: P, params: PathParams<P>): string {
  let newPath: string = path;
  Object.entries(params).forEach(([key, value]) => {
    newPath = newPath.replace(`:${key}`, value);
  });
  return newPath;
}

/**
 * These have to be in a separate component
 * so that the hook is only triggered if there is no match
 * for the invite route.
 */
export const AuthenticatedRoutes = () => {
  const { isLoading } = useAuthInitEffect();

  if (isLoading) {
    return null;
  }

  return (
    <AuthenticatedApi>
      <Switch>
        <Route path={Paths.project} render={({ match }) => <ProjectRouter {...match.params} />}>
          {/* <Layout> */}
          {/*<Route path="/global">*/}
          {/*  <NavigationItems items={navigationItems}  />*/}

          {/*  <Switch>*/}
          {/*    <Route exact path={Paths.userDetails(':userId')} component={TeamMemberDetailsGlobalPage} />*/}
          {/*    <Route exact path={Paths.userAccess()} component={TeamMembersListGlobalPage} />*/}

          {/*    <Route>*/}
          {/*      <Redirect to={Paths.userAccess()} />*/}
          {/*    </Route>*/}
          {/*  </Switch>*/}
          {/*</Route>*/}
          {/*  </Layout> */}
        </Route>

        <Route component={NoProjectPage} />
      </Switch>
    </AuthenticatedApi>
  );
};

export const Routes = () => {
  const location = useLocation();
  useEffect(() => {
    console.debug('Route change: ', location.pathname);
  }, [location.pathname]);
  return (
    <Switch>
      <Route path={Paths.invite} render={() => <InviteLandingPage />} />
      <Route path={Paths.login} render={() => <Login />} />
      <AuthenticatedRoutes />
    </Switch>
  );
};
